// extracted by mini-css-extract-plugin
export var currencyInput = "_ma-1";
export var currencySymbol = "_ma-0";